
/**
 * Use for label's property field key name
 */
export const api = {
    sender: {
        BRANCH: "source_branch_id",
        RAW_BRANCH: "branch",
        NAME: "source_name",
        PHONES: "source_phone",
        POSTCODE: "source_postcode", // quarter zip code
        BRANCH_POSTCODE: "source_branch_postcode",  // branch postcode
        LOCATION_POSTCODE: "location_postcode",
        HOMENO: "source_no",
        STREET: "source_street",
        QUARTER: "source_quarter",
        TOWNSHIP: "source_township",
        TOWN: "source_town",
        REGION: "source_region",
        MERCHANT_ID: "merchant_id",
        MERCHANT: "merchant",
        SLUG: "source_alpha_3_code",
        NRC: "source_nrc",
        CUSTOMERID:"customer_id",
        ADDRESS: "source_address",
        WITH_TEMP_ADDRESS : "with_temp_address",
        INSURANCE_PERCENT: "insurance_percent",
    },
    receiver: {
        BRANCH: "deliver_branch_id",
        RAW_BRANCH: "branch",
        NAME: "destination_name",
        PHONES: "destination_phone",
        POSTCODE: "destination_postcode", // quarter zipcode
        BRANCH_POSTCODE: "destination_branch_postcode", // branch postcode
        LOCATION_POSTCODE: "location_postcode",
        HOMENO: "destination_no",
        STREET: "destination_street",
        QUARTER: "destination_quarter",
        TOWNSHIP: "destination_township",
        TOWN: "destination_town",
        REGION: "destination_region",
        PICKUP_AT_PO: "pickup_at_po",
        CONTACT_PHONE_LIST: "contact_phone_list",
        SLUG: "destination_alpha_3_code",
        NRC: "destination_nrc",
        DELIVERY_TYPE: "delivery_type",
        TYPE: "type",
        ADDRESS: "destination_address",
    },
    parcel: {
        INCLUDE_PRODUCT: "include_products",
        ITEM_TYPE: "item_type",
        WEIGHT: "weight",
        SERVICE_TYPE: "service_type",
        ACCEPT_TYPE: "accept_type",
        RATING_TYPE: "rating_type",
        PURCHASE_TYPE: "purchase_type",
        FLAT: "flat",
        TIME_REQUEST: "time_request",
        TIME_REQUEST_FROM: "from",
        TIME_REQUEST_TO: "to",
        REFERENCE: "reference_id",
        REMARK: "remark",
        VERSION: "version",
    },
    other: {
        STATUS: "status",
        TRACKING_CODE: "tracking_code",
        AGENT_ID: "agent_id",
        BRANCH_ID: "branch_id",
        SERVICES: "services",
        SERVICES_FEE: "services_fee",
        COMPENSATION_FEE: "compensation_fee",
        TOTAL_COST: "total_cost",
        TRANSACTIONS: "logs",
        CREATED_AT: "created_at",
        CREATOR: "creator",
        FINISH:"finish_item",
        TRANSACTIONLABEL:"transaction_label",
        WITH_SMART_INVOICE: "with_smart_invoice",
        INSURANCE_FEE: "insurance_fee",
        GATE_SUBMIT: "gate_submit"
    }
};

export const emo_form = {
    sender_recevier: {
        BRANCH: "branch",
        NAME: "name",
        PHONES: "phone",
        HOMENO: "no",
        STREET: "street",
        QUARTER: "quarter",
        TOWNSHIP: "township",
        TOWN: "town",
        REGION: "region",
        NRC: "nrc",
        POSTCODE: "postcode"
    },
    parcel: {
        SERVICE_TYPE: "accept_type",
        PURCHASE_TYPE: "purchase_type"
    },
    other: {
        STATUS: "status",
        SERVICES_FEE: "services_fee"
    }
};

const label_service_type = {
    REGISTER: "register",
    EXPRESS: "express",
    SPECIAL: "special",
    VPP: "vpp",
    VPL: "vpl"
};

export const cod_services_state = {
    STATUS_ONGOING: "ongoing",
    STATUS_PROCESS: "process",
    STATUS_READY_TO_CLEARANCE: "ready_to_clearance",
    STATUS_CLEARANCE: "clearance",
    STATUS_COMPLETE: "complete",
    STATUS_CANCEL: "cancel"
};

export const cod_clearance_transaction_state = {
    STATUS_PENDING: "pending",
    STATUS_COMPLETE: "complete"
};

export const emo_services_state = {
    STATUS_PENDING: "pending",
    STATUS_PROCESS: "process",
    STATUS_COMPLETE: "complete",
    STATUS_CANCEL: "cancel",
    STATUS_RETURNED: "returned"
};

export const remark_type_enum = {
    TYPE_EMO_RETURN: "emo_return"
};

export const calcualtor_form = {
    SERVICE_TYPE: "service_type",
    WEIGHT: "weight",
    SOURCE_POSTCODE: "source_postcode",
    DESTINATION_POSTCODE: "destination_postcode",
    ITEM_TYPE: "item_type",
    FLIGHT_SERVICE: "flight_service"
};

// Use for services' key name
export const services = {
    name: {
        SMS_SERVICE: "sms",
        PHONE_CALL_SERVICE: "phone_call",
        COD_SERVICE: "cod",
        PICKUP_SERVICE: "pickup_service",
        POD: "pod",
        VFL: "vfl",
        SHIPPING: "shipping",
        OPS: "ops",
        STAMPED: "stamped",
        ACTIVATED: "activated",
        NOTACTIVATED:"not_activated",
        PREPRINT: "preprint",
        PICKUP_AT_LS: "pickup_at_parcel_locker",
        FREE_FLIGHT_FEE: "free_flight_fee",
        INSTANT_DELIVER: "instant_deliver",
        FULL_SERVICE: "full_service",
        QUICK_PAY: "quick_pay",
        INSURANCE_AMOUNT: "insurance_amount",
        INSURANCE_PERCENT: "insurance_percent",
        SET_INSURANCE_AMOUNT: "set_insurance_amount",
        GATE_SUBMIT: "gate_submit",
        CAN_VIEW_GATE_SUBMIT: "can_view_gate_submit",
        CAN_VIEW_INSURANCE: "can_view_insurance",
        GATE_SUBMIT_AMOUNT: "gate_submit_amount",
        GATE_SUBMIT_COLLECTED: "gate_submit_collected"
    },
    fee: {
        SMS_FEE: "sms_fee",
        AGENT_SERVICE_MPOST_SHIPPING_FEE: "agent_service_mpost_shipping_fee",
        AGENT_SERVICE_API_FEE: "agent_service_api_fee",
        SHIPPING_FEE: "shipping_fee",
        MPOST_SHIPPING_FE: "mpost_shipping_fee",
        COD_FEE: "cod_fee",
        COD_CHARGE: "cod_charge",
        PHONE_CALL_FEE: "phone_call_fee",
        POD_FEE: "pod_fee",
        TAX_FEE: "tax_fee",
        VFL_FEE: "vfl_fee",
        PICKUP_SERVICE_FEE: "pickup_service_fee",
        INSTANT_DELIVER_FEE: "instant_deliver_fee",
        RETURN_FEE: "return_fee",
        HOLE_MAIL_FEE: "hold_mail_fee",
        CHANGE_DESTINATION_FEE: "change_destination_fee",
        CANCELLATION_FEE: "cancellation_fee",
        ZA_FEE: "za_fee",
        CASH_COLLECT_FEE: "cash_collect_fee",
        MPOST_FEE: "mpost_fee",
        STAMPED_SHIPPING_FEE: "stamped_shipping_fee",
        PICKUP_LOCKER_FEE : "pickup_locker_fee",
        AGENT_FEE_ACCEPT: "agent_fee_accept",
        AGENT_FEE_DELIVER: "agent_fee_deliver",
        AGENT_FEE_FULL_SERVICE: "agent_fee_full_service",
        ZA_FEE_ACCEPT: "za_fee_accept",
        ZA_FEE_DELIVER: "za_fee_deliver",
        ZA_FEE_FULL_SERVICE: "za_fee_full_service",
        MPOST_FEE_ACCEPT: "mpost_fee_accept",
        MPOST_FEE_DELIVER: "mpost_fee_deliver",
        MPOST_FEE_FULL_SERVICE: "mpost_fee_full_service",
        AGENT_DISCOUNT: "agent_discount",
        CFR_AMOUNT: "cfr_amount",
        FLIGHT_FEE: "flight_fee",
        DISCOUNT: "discount",
        FCS_SHIPPING_FEE: "fcs_shipping_fee",
        INSURANCE_AMOUNT: "insurance_amount",
        INSURANCE_PERCENT: "insurance_percent",
        INSURANCE_FEE: "insurance_fee",
        GATE_SUBMIT_AMOUNT: "gate_submit_amount",
        GATE_SUBMIT_COLLECTED_FEE: "collected_gate_submit_fee",
        GATE_SUBMIT_FEE: "gate_submit_fee"

    },
    phones: {
        PHONE_FOR_SERVICE: "phones"
    },
    rates: {
        sms: 100,
        phone_call: 100,
        pickup_service: 500
    }
};

export const enum_services_matcher = {
    [services.name.SMS_SERVICE]: services.fee.SMS_FEE,
    [services.name.PHONE_CALL_SERVICE]: services.fee.PHONE_CALL_FEE,
    [services.name.COD_SERVICE]: services.fee.COD_FEE,
    [services.name.PICKUP_SERVICE]: services.fee.PICKUP_SERVICE_FEE,
    [services.name.SHIPPING]: services.fee.SHIPPING_FEE
};

// Use for services' key name to parse locale key name
export const service_locale_enum = {
    // use to change services and services fee keys to locale key
    [services.fee.COD_FEE]: "cod_fee",
    [services.fee.SMS_FEE]: "sms_service_fee",
    [services.fee.SHIPPING_FEE]: "shipping_service_fee",
    [services.fee.PICKUP_SERVICE_FEE]: "pickup_service_fee",
    [services.fee.PHONE_CALL_FEE]: "phonecall_service_fee",
    [services.fee.TAX_FEE]: "tax",
    [services.fee.RETURN_FEE]: "return_fee",
    [services.fee.POD_FEE]: "pod_fee",
    [services.fee.VFL_FEE]: "vfl_fee",
    [services.fee.HOLE_MAIL_FEE]: "hold_mail_fee",
    [services.fee.CHANGE_DESTINATION_FEE]: "change_destination_fee",
    [services.fee.CANCELLATION_FEE]: "cancelation_fee",
    [services.fee.ZA_FEE]: "za_fee",
    [services.fee.POSTMAN_ALLOWANCE]: "postman_allowance",
    [services.fee.CASH_COLLECT_FEE]: "cash_collect_fee",
    [services.name.SMS_SERVICE]: "sms_service",
    [services.name.COD_SERVICE]: "cod_service",
    [services.name.SHIPPING]: "shipping_service",
    [services.name.PICKUP_SERVICE]: "pickup_service",
    [services.name.PHONE_CALL_SERVICE]: "phone_call_service"
};

// Use for label status key
export const label_status_enum = {
    PENDING: "pending",
    ACCEPT_FROM_ORIGIN_BRANCH: "accept_from_origin_branch",
    ACCEPT_BY_TRANSPORT: "accept_by_transport",
    SENDBACK_TO_TRANSPORT: "sendback_to_transport",
    SEND_TO_DESTINATION_BRANCH: "send_to_destination_branch",
    ARRIVED_TO_DESTINATION_BRANCH: "arrived_to_destination_branch",
    SEND_TO_DESTINATION_ADDRESS: "send_to_destination_address",

    DELIVERED: "delivered",
    SENTBACK_TO_CUSTOMER: "sentback_to_customer",

    // If forward label, require this status before "ARRIVED_TO_DESTINATION_BRANCH"
    SEND_TO_FORWARD_BRANCH: "send_to_forward_branch",
    ARRIVED_TO_FORWARD_BRANCH: "arrived_to_forward_branch",
    SEND_FROM_FORWARD_BRANCH: "send_from_forward_branch",

    // If redirect label, require this status before "SEND_TO_DESTINATION_ADDRESS"
    SEND_FROM_REDIRECT_BRANCH: "send_from_redirect_branch",

    // If return label, require this status after "SEND_TO_DESTINATION_ADDRESS"
    SENDBACK_TO_DESTINATION_BRANCH: "sendback_to_destination_branch",
    SENDBACK_TO_ORIGIN_BRANCH: "sendback_to_origin_branch",
    ARRIVED_TO_ORIGIN_BRANCH: "arrived_to_origin_branch",
    SENDBACK_TO_ORIGIN_ADDRESS: "sendback_to_origin_address",

    MISSING: "missing",
    REDIRECTED: "redirected",
    REJECT: "reject",
    RETURN_CONFIRM: "return_confirmed",
    PENDING_REJECT: "pending_reject",
    PENDING_RETURN_CONFIRM: "pending_return_confirm"
};

export const label_status_locale_enum = {
    [label_status_enum.PENDING]: "pending_status",
    [label_status_enum.ACCEPT_FROM_ORIGIN_BRANCH]:
        "accept_from_origin_branch_status",
    [label_status_enum.ACCEPT_BY_TRANSPORT]: "accept_by_transport_status",
    [label_status_enum.SENDBACK_TO_TRANSPORT]: "sendback_to_transport_status",
    [label_status_enum.SEND_TO_DESTINATION_BRANCH]:
        "send_to_destination_branch_status",
    [label_status_enum.ARRIVED_TO_DESTINATION_BRANCH]:
        "arrived_to_destination_branch_status",
    [label_status_enum.SEND_TO_DESTINATION_ADDRESS]:
        "send_to_destination_address_status",
    [label_status_enum.DELIVERED]: "delivered_status",
    [label_status_enum.SENTBACK_TO_CUSTOMER]: "sentback_to_customer_status",
    [label_status_enum.REDIRECTED]: "redirected_status",

    [label_status_enum.SEND_TO_FORWARD_BRANCH]: "send_to_forward_branch_status",
    [label_status_enum.ARRIVED_TO_FORWARD_BRANCH]:
        "arrived_to_forward_branch_status",
    [label_status_enum.SEND_FROM_FORWARD_BRANCH]:
        "send_from_forward_branch_status",
    [label_status_enum.SEND_FROM_REDIRECT_BRANCH]: "send_from_redirect_branch_status",

    [label_status_enum.SENDBACK_TO_DESTINATION_BRANCH]:
        "sendback_to_destination_branch_status",
    [label_status_enum.SENDBACK_TO_ORIGIN_BRANCH]: "sendback_to_origin_branch_status",
    [label_status_enum.ARRIVED_TO_ORIGIN_BRANCH]: "arrived_to_origin_branch_status",
    [label_status_enum.SENDBACK_TO_ORIGIN_ADDRESS]:
        "sendback_to_origin_address_status",
    [label_status_enum.MISSING]: "missing_status"
};

// Use to get label status key step by step
export const label_status_process_enum = {
    normal: [
        "PENDING",
        "ACCEPT_FROM_ORIGIN_BRANCH",
        //'ACCEPT_BY_TRANSPORT',
        "SEND_TO_DESTINATION_BRANCH",
        "ARRIVED_TO_DESTINATION_BRANCH",
        "SEND_TO_DESTINATION_ADDRESS",
        "DELIVERED"
    ],
    direct: [
        "PENDING",
        "ACCEPT_FROM_ORIGIN_BRANCH",
        "SEND_TO_DESTINATION_ADDRESS",
        "DELIVERED"
    ],
    direct_return: [
        "PENDING",
        "ACCEPT_FROM_ORIGIN_BRANCH",
        "SEND_TO_DESTINATION_ADDRESS",
        "SENDBACK_TO_ORIGIN_BRANCH",
        "SENDBACK_TO_ORIGIN_ADDRESS",
        "SENTBACK_TO_CUSTOMER" //edited DELIVER
    ],
    fail_return: [
        "SENDBACK_TO_ORIGIN_BRANCH",
        "SENDBACK_TO_ORIGIN_ADDRESS",
        "SENDBACK_TO_ORIGIN_BRANCH",
        "SENDBACK_TO_ORIGIN_ADDRESS"
    ],
    forward: [
        "PENDING",
        "ACCEPT_FROM_ORIGIN_BRANCH",
        //'ACCEPT_BY_TRANSPORT',
        "SEND_TO_FORWARD_BRANCH",
        "ARRIVED_TO_FORWARD_BRANCH",
        "SEND_FROM_FORWARD_BRANCH",
        //'ACCEPT_BY_TRANSPORT',
        "SEND_TO_DESTINATION_BRANCH",
        "ARRIVED_TO_DESTINATION_BRANCH",
        "SEND_TO_DESTINATION_ADDRESS",
        "DELIVERED"
    ],
    redirect: [
        "PENDING",
        "ACCEPT_FROM_ORIGIN_BRANCH",
        //'ACCEPT_BY_TRANSPORT',
        "SEND_TO_DESTINATION_BRANCH",
        "ARRIVED_TO_DESTINATION_BRANCH",
        "REDIRECTED",
        "SEND_FROM_REDIRECT_BRANCH",
        //'ACCEPT_BY_TRANSPORT',
        "SEND_TO_DESTINATION_BRANCH",
        "ARRIVED_TO_DESTINATION_BRANCH",
        "SEND_TO_DESTINATION_ADDRESS",
        "DELIVERED"
    ],
    return: [
        "PENDING",
        "ACCEPT_FROM_ORIGIN_BRANCH",
        //'ACCEPT_BY_TRANSPORT',
        "SEND_TO_DESTINATION_BRANCH",
        "ARRIVED_TO_DESTINATION_BRANCH",
        "SEND_TO_DESTINATION_ADDRESS",
        "SENDBACK_TO_DESTINATION_BRANCH",
        "ARRIVED_TO_DESTINATION_BRANCH",
        "SENDBACK_TO_ORIGIN_BRANCH",
        //'SENDBACK_TO_TRANSPORT',
        "ARRIVED_TO_ORIGIN_BRANCH",
        "SENDBACK_TO_ORIGIN_ADDRESS",
        "SENTBACK_TO_CUSTOMER"
    ]
};

export const label_status_process_permission_enum = {
    normal: {
        "PENDING" : {
            "sender": true,
            "receiver": false
        },
        "ACCEPT_FROM_ORIGIN_BRANCH" : {
            "sender": true,
            "receiver": false
        },
        //'ACCEPT_BY_TRANSPORT',
        "SEND_TO_DESTINATION_BRANCH" : {
            "sender": true,
            "receiver": false
        },
        "ARRIVED_TO_DESTINATION_BRANCH" : {
            "sender": false,
            "receiver": true
        },
        "SEND_TO_DESTINATION_ADDRESS": {
            "sender": false,
            "receiver": true
        },
        "DELIVERED": {
            "sender": false,
            "receiver": true
        }
    },
    direct: {
        "PENDING": {
            "sender": true,
            "receiver": true
        },
        "ACCEPT_FROM_ORIGIN_BRANCH": {
            "sender": true,
            "receiver": true
        },
        "SEND_TO_DESTINATION_ADDRESS": {
            "sender": true,
            "receiver": true
        },
        "DELIVERED": {
            "sender": true,
            "receiver": true
        }
    },
    direct_return: {
        "PENDING"  : {
            "sender": true,
            "receiver": true
        },
        "ACCEPT_FROM_ORIGIN_BRANCH": {
            "sender": true,
            "receiver": true
        },
        "SEND_TO_DESTINATION_ADDRESS": {
            "sender": true,
            "receiver": true
        },
        "SENDBACK_TO_ORIGIN_BRANCH": {
            "sender": true,
            "receiver": true
        },
        "SENDBACK_TO_ORIGIN_ADDRESS": {
            "sender": true,
            "receiver": true
        },
        "SENTBACK_TO_CUSTOMER": {
            "sender": true,
            "receiver": true
        } //edited DELIVER
    },
    forward: {
        "PENDING": {
            "sender": true,
            "receiver": false
        },
        "ACCEPT_FROM_ORIGIN_BRANCH": {
            "sender": true,
            "receiver": false
        },
        //'ACCEPT_BY_TRANSPORT',
        "SEND_TO_FORWARD_BRANCH": {
            "sender": true,
            "receiver": true,
            "all": true
        },
        "ARRIVED_TO_FORWARD_BRANCH": {
            "sender": true,
            "receiver": true,
            "all": true
        },
        "SEND_FROM_FORWARD_BRANCH": {
            "sender": true,
            "receiver": true,
            "all": true
        },
        //'ACCEPT_BY_TRANSPORT',
        "SEND_TO_DESTINATION_BRANCH": {
            "sender": true,
            "receiver": true,
            "all": true
        },
        "ARRIVED_TO_DESTINATION_BRANCH": {
            "sender": false,
            "receiver": true
        },
        "SEND_TO_DESTINATION_ADDRESS": {
            "sender": false,
            "receiver": true
        },
        "DELIVERED": {
            "sender": false,
            "receiver": true
        }
    },
    redirect: {
        "PENDING" : {
            "sender": true,
            "receiver": false
        },
        "ACCEPT_FROM_ORIGIN_BRANCH" : {
            "sender": true,
            "receiver": false
        },
        //'ACCEPT_BY_TRANSPORT',
        "SEND_TO_DESTINATION_BRANCH": {
            "sender": true,
            "receiver": false
        },
        "ARRIVED_TO_DESTINATION_BRANCH" : {
            "sender": false,
            "receiver": true
        },
        "REDIRECTED" : {
            "sender": true,
            "receiver": true
        },
        "SEND_FROM_REDIRECT_BRANCH" : {
            "sender": true,
            "receiver": true
        },
        // //'ACCEPT_BY_TRANSPORT',
        // "SEND_TO_DESTINATION_BRANCH": {
        //     "sender": true,
        //     "receiver": true
        // },
        // "ARRIVED_TO_DESTINATION_BRANCH": {
        //     "sender": false,
        //     "receiver": true
        // },
        "SEND_TO_DESTINATION_ADDRESS":{
            "sender": false,
            "receiver": true
        },
        "DELIVERED":{
            "sender": false,
            "receiver": true
        }
    },
    return: {
        "PENDING" : {
            "sender": true,
            "receiver": false
        },
        "ACCEPT_FROM_ORIGIN_BRANCH" : {
            "sender": true,
            "receiver": false
        },
        //'ACCEPT_BY_TRANSPORT',
        "SEND_TO_DESTINATION_BRANCH" : {
            "sender": true,
            "receiver": false
        },
        "ARRIVED_TO_DESTINATION_BRANCH" : {
            "sender": true,
            "receiver": false
        },
        "SEND_TO_DESTINATION_ADDRESS" : {
            "sender": true,
            "receiver": false
        },
        "SENDBACK_TO_DESTINATION_BRANCH" : {
            "sender": true,
            "receiver": false
        },
        "ARRIVEDBACK_TO_DESTINATION_BRANCH" : {
            "sender": true,
            "receiver": false
        },
        "SENDBACK_TO_ORIGIN_BRANCH" : {
            "sender": true,
            "receiver": false
        },
        //'SENDBACK_TO_TRANSPORT',
        "ARRIVED_TO_ORIGIN_BRANCH" : {
            "sender": true,
            "receiver": false
        },
        "ARRIVEDBACK_TO_ORIGIN_BRANCH" : {
            "sender": true,
            "receiver": false
        },
        "SENDBACK_TO_ORIGIN_ADDRESS" : {
            "sender": true,
            "receiver": false
        },
        "SENTBACK_TO_CUSTOMER" : {
            "sender": true,
            "receiver": false
        }
    }
};

export const label_status_recognize_key = {
    // to recognize label's shipping type by see label's current status list (list contain the following status or not) => search latest from backward
    [label_status_enum.SENDBACK_TO_DESTINATION_BRANCH]: "return",
    [label_status_enum.SENDBACK_TO_ORIGIN_BRANCH]: "return",
    [label_status_enum.SEND_FROM_REDIRECT_BRANCH]: "redirect",
    [label_status_enum.SEND_FROM_FORWARD_BRANCH]: "forward",
};


export const region_slug = {
    "Kachin State": "KCN",
    "Kayah State": "KYA",
    "Kayin State": "KYN",
    "Chin State": "CHN",
    "Sagaing Region": "SGI",
    "Tanintharyi Region": "TYG",
    "Bago Region (East)": "BGOE",
    "Bago Region (West)": "BGOW",
    "Magway Region": "MGW",
    "Mandalay Region": "MDY",
    "Mon State": "MON",
    "Rakhine State": "RKH",
    "Yangon Region": "YGN",
    "Shan State (South)": "SHNS",
    "Shan State (North)": "SHNN",
    "Shan State (East)": "SHNE",
    "Ayeyarwady Region": "AYY",
    "Naypyitaw Union Territory": "NPT"
};

export const country_slug = {
    "AF": "Afghanistan",
    "AL": "Albania",
    "DZ": "Algeria",
    "AS": "American Samoa",
    "AD": "Andorra",
    "AO": "Angola",
    "AI": "Anguilla",
    "AQ": "Antarctica",
    "AG": "Antigua and Barbuda",
    "AR": "Argentina",
    "AM": "Armenia",
    "AW": "Aruba",
    "AU": "Australia",
    "AT": "Austria",
    "AZ": "Azerbaijan",
    "BS": "Bahamas",
    "BH": "Bahrain",
    "BD": "Bangladesh",
    "BB": "Barbados",
    "BY": "Belarus",
    "BE": "Belgium",
    "BZ": "Belize",
    "BJ": "Benin",
    "BM": "Bermuda",
    "BT": "Bhutan",
    "BO": "Bolivia",
    "BA": "Bosnia and Herzegovina",
    "BW": "Botswana",
    "BV": "Bouvet Island",
    "BR": "Brazil",
    "IO": "British Indian Ocean Territory",
    "BN": "Brunei Darussalam",
    "BG": "Bulgaria",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "KH": "Cambodia",
    "CM": "Cameroon",
    "CA": "Canada",
    "CV": "Cape Verde",
    "KY": "Cayman Islands",
    "CF": "Central African Republic",
    "TD": "Chad",
    "CL": "Chile",
    "CN": "China",
    "CX": "Christmas Island",
    "CC": "Cocos (Keeling) Islands",
    "CO": "Colombia",
    "KM": "Comoros",
    "CG": "Congo",
    "CD": "Congo, the Democratic Republic of the",
    "CK": "Cook Islands",
    "CR": "Costa Rica",
    "CI": "Cote D'Ivoire",
    "HR": "Croatia",
    "CU": "Cuba",
    "CY": "Cyprus",
    "CZ": "Czech Republic",
    "DK": "Denmark",
    "DJ": "Djibouti",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "EC": "Ecuador",
    "EG": "Egypt",
    "SV": "El Salvador",
    "GQ": "Equatorial Guinea",
    "ER": "Eritrea",
    "EE": "Estonia",
    "ET": "Ethiopia",
    "FK": "Falkland Islands (Malvinas)",
    "FO": "Faroe Islands",
    "FJ": "Fiji",
    "FI": "Finland",
    "FR": "France",
    "GF": "French Guiana",
    "PF": "French Polynesia",
    "TF": "French Southern Territories",
    "GA": "Gabon",
    "GM": "Gambia",
    "GE": "Georgia",
    "DE": "Germany",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GR": "Greece",
    "GL": "Greenland",
    "GD": "Grenada",
    "GP": "Guadeloupe",
    "GU": "Guam",
    "GT": "Guatemala",
    "GN": "Guinea",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HT": "Haiti",
    "HM": "Heard Island and Mcdonald Islands",
    "VA": "Holy See (Vatican City State)",
    "HN": "Honduras",
    "HK": "Hong Kong",
    "HU": "Hungary",
    "IS": "Iceland",
    "IN": "India",
    "ID": "Indonesia",
    "IR": "Iran, Islamic Republic of",
    "IQ": "Iraq",
    "IE": "Ireland",
    "IL": "Israel",
    "IT": "Italy",
    "JM": "Jamaica",
    "JP": "Japan",
    "JO": "Jordan",
    "KZ": "Kazakhstan",
    "KE": "Kenya",
    "KI": "Kiribati",
    "KP": "Korea, Democratic People's Republic of",
    "KR": "Korea, Republic of",
    "KW": "Kuwait",
    "KG": "Kyrgyzstan",
    "LA": "Lao People's Democratic Republic",
    "LV": "Latvia",
    "LB": "Lebanon",
    "LS": "Lesotho",
    "LR": "Liberia",
    "LY": "Libyan Arab Jamahiriya",
    "LI": "Liechtenstein",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "MO": "Macao",
    "MK": "Macedonia, the Former Yugoslav Republic of",
    "MG": "Madagascar",
    "MW": "Malawi",
    "MY": "Malaysia",
    "MV": "Maldives",
    "ML": "Mali",
    "MT": "Malta",
    "MH": "Marshall Islands",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MU": "Mauritius",
    "YT": "Mayotte",
    "MX": "Mexico",
    "FM": "Micronesia, Federated States of",
    "MD": "Moldova, Republic of",
    "MC": "Monaco",
    "MN": "Mongolia",
    "MS": "Montserrat",
    "MA": "Morocco",
    "MZ": "Mozambique",
    "MM": "Myanmar",
    "NA": "Namibia",
    "NR": "Nauru",
    "NP": "Nepal",
    "NL": "Netherlands",
    "AN": "Netherlands Antilles",
    "NC": "New Caledonia",
    "NZ": "New Zealand",
    "NI": "Nicaragua",
    "NE": "Niger",
    "NG": "Nigeria",
    "NU": "Niue",
    "NF": "Norfolk Island",
    "MP": "Northern Mariana Islands",
    "NO": "Norway",
    "OM": "Oman",
    "PK": "Pakistan",
    "PW": "Palau",
    "PS": "Palestinian Territory, Occupied",
    "PA": "Panama",
    "PG": "Papua New Guinea",
    "PY": "Paraguay",
    "PE": "Peru",
    "PH": "Philippines",
    "PN": "Pitcairn",
    "PL": "Poland",
    "PT": "Portugal",
    "PR": "Puerto Rico",
    "QA": "Qatar",
    "RE": "Reunion",
    "RO": "Romania",
    "RU": "Russian Federation",
    "RW": "Rwanda",
    "SH": "Saint Helena",
    "KN": "Saint Kitts and Nevis",
    "LC": "Saint Lucia",
    "PM": "Saint Pierre and Miquelon",
    "VC": "Saint Vincent and the Grenadines",
    "WS": "Samoa",
    "SM": "San Marino",
    "ST": "Sao Tome and Principe",
    "SA": "Saudi Arabia",
    "SN": "Senegal",
    "CS": "Serbia and Montenegro",
    "SC": "Seychelles",
    "SL": "Sierra Leone",
    "SG": "Singapore",
    "SK": "Slovakia",
    "SI": "Slovenia",
    "SB": "Solomon Islands",
    "SO": "Somalia",
    "ZA": "South Africa",
    "GS": "South Georgia and the South Sandwich Islands",
    "ES": "Spain",
    "LK": "Sri Lanka",
    "SD": "Sudan",
    "SR": "Suriname",
    "SJ": "Svalbard and Jan Mayen",
    "SZ": "Swaziland",
    "SE": "Sweden",
    "CH": "Switzerland",
    "SY": "Syrian Arab Republic",
    "TW": "Taiwan, Province of China",
    "TJ": "Tajikistan",
    "TZ": "Tanzania, United Republic of",
    "TH": "Thailand",
    "TL": "Timor-Leste",
    "TG": "Togo",
    "TK": "Tokelau",
    "TO": "Tonga",
    "TT": "Trinidad and Tobago",
    "TN": "Tunisia",
    "TR": "Turkey",
    "TM": "Turkmenistan",
    "TC": "Turks and Caicos Islands",
    "TV": "Tuvalu",
    "UG": "Uganda",
    "UA": "Ukraine",
    "AE": "United Arab Emirates",
    "GB": "United Kingdom",
    "US": "United States",
    "UM": "United States Minor Outlying Islands",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VU": "Vanuatu",
    "VE": "Venezuela",
    "VN": "Viet Nam",
    "VG": "Virgin Islands, British",
    "VI": "Virgin Islands, U.s.",
    "WF": "Wallis and Futuna",
    "EH": "Western Sahara",
    "YE": "Yemen",
    "ZM": "Zambia",
    "ZW": "Zimbabwe"
}

export const mailbag_process_enum = {
    PENDING: "pending",
    PROCESS: "process",
    CHECK_IN: "checkin_transit",
    CHECK_OUT: "checkout_transit",
    COMPLETE: "complete"
};

export const report_region_chooser_enum = {
    ALL: "all_branch",
    REGION: "branch_collection",
    BRANCH: "branch"
};

export const report_period_enum = {
    DAILY: "daily",
    MONTHLY: "monthly",
    YEARLY: "yearly",
    DATE_RANGE: "range"
};

export const export_type_enum = {
    BRANCH: "branch",
    REGION: "branch_collection",
    ALL: "all_branch"
};

export const export_customer_enum = {
    CUSTOMER: "customer",
    ALL_CUSTOMER: "all_customer",
    ALL: "all"
}

export const report_type_enum = {
    // CUSTOM: {
    //     type: "custom",
    //     text: "Custom Select"
    // },
    WALKIN_EXPRESS: {
        type: "walkin_express",
        text: "Walkin Express"
    },
    WALKIN_REGISTER: {
        type: "walkin_register",
        text: "Walkin Register"
    },
    WALKIN_OPS: {
        type: "walkin_ops",
        text: "Walkin OPSs"
    },
    ONLINE_EXPRESS: {
        type: "online_express",
        text: "Online Express"
    },
    ONLINE_VPP: {
        type: "online_vpp",
        text: "Online VPP"
    },
    ONLINE_VPL: {
        type: "online_vpl",
        text: "Online VPL"
    },
    ONLINE_REGISTER: {
        type: "online_register",
        text: "Online Register"
    },
    ONLINE_RETURN: {
        type: "online_return",
        text: "Online Return"
    },
    SMS: {
        type: "sms",
        text: "SMS"
    },
    HOLD_MAIL: {
        type: "hold_mail",
        text: "Hold Mail"
    },
    EMO: {
        type: "emo",
        text: "EMO System"
    },
    PHONECALL: {
        type: "phone",
        text: "Phone Call Service"
    },
    API: {
        type: "api",
        text: "API Transaction"
    }
};


export const services_pricing = {
    rate: {
        [services.name.SMS_SERVICE]: 0,
        [services.name.PHONE_CALL_SERVICE]: 0,
        [services.name.COD_SERVICE]: (amount) => { return amount < 300000 ? 2 : 1},
        [services.name.PICKUP_SERVICE]: 0,
        [services.name.POD]: 0,
        [services.name.VFL]: 0
    }
};

export const services_pricing_formula = {
    [services.name.SMS_SERVICE]: phoneCount =>
        phoneCount * services_pricing.rate[services.name.SMS_SERVICE],
    [services.name.PHONE_CALL_SERVICE]: phoneCount =>
        phoneCount * services_pricing.rate[services.name.PHONE_CALL_SERVICE],
    [services.name.COD_SERVICE]: amount => (amount / 100) * services_pricing.rate[services.name.COD_SERVICE](amount),
    [services.name.PICKUP_SERVICE]: () => services_pricing.rate[services.name.PICKUP_SERVICE],
    [services.name.POD]: services_pricing.rate[services.name.POD],
    [services.name.VFL]: services_pricing.rate[services.name.VFL]
};

export const location_type = {
    REGION : 'region',
    TOWN: "town",
    TOWNSHIP: "township",
    QUARTER: "quarter",
    VILLAGE: "village_tract",
    STREET: "street"
};

export const location_response = {
    ID: 'id',
    NAME_EN: "name_en",
    NAME_MM: "name_mm",
    POSTCODE: "postcode",
    BRANCH_POSTCODE: "branch_postcode",
    TYPE: "type",
    PARENT_ID: "parent_id",
    PARENT_TYPE: "parent_type"
};

const tab_status_enum = {
    accept_enum: {
        inbox: 's_pending_count',
        pending: 's_accept_count',
        ims_ems: "s_international_count",
        ongoing: 's_send_count',
        ondelivery: label_status_enum.SEND_TO_DESTINATION_ADDRESS,
        sent: 's_delivered_count',
        return: 's_return_count',
        resent_return: label_status_enum.SENTBACK_TO_CUSTOMER,
        send_back_to_source: 's_returned_count',
        issue_pending: label_status_enum.SEND_FROM_REDIRECT_BRANCH,
        issue: label_status_enum.MISSING
    },
    deliver_enum: {
        inbox: 'd_pending_count',
        pending: 'd_delivery_pending_count',
        pickup: 'd_pending_pickup_count',
        ongoing: 'd_send_count',
        delivered: 'd_delivered_count',
        fail_deliver: 'd_fail_deliver_count',
        return: 'd_return_count',
        resent_return: label_status_enum.SENDBACK_TO_ORIGIN_ADDRESS,
        send_back_to_source: 'd_returned_count',
        issue_pending: label_status_enum.SEND_FROM_REDIRECT_BRANCH,
        issue: label_status_enum.MISSING
    }
};

const agent_service_status = {
    STATUS_PENDING : 'pending',
    STATUS_CONFIRM: "confirm",
    STATUS_DENIED: "denied"
};

const agent_available_services = {
    LABEL_ACCEPT: 'label_accept',
    LABEL_DELIVER: 'label_deliver',
    MAILBAG_OUTBOUND: 'mailbag_outbound',
    MAILBAG_INBOUND: 'mailbag_inbound'
};

const pickup_request_status_enum  = {
    UNASSIGNED: "unassigned",
    PENDING: "pending",
    ONGOING: "ongoing",
    COMPLETE: "complete",
    HANDOVER: "handover",
    FAILED: "failed"
};


const pickup_request_log_status_enum = {
    UNASSIGNED: "unassigned",
    PENDING: "pending",
    ACCEPT: "accept",
    DENY: "deny",
    COMPLETE: "complete",
    HANDOVER: "handover",
    FAILED: "failed"
};


const pickup_request_api_enum = {
    BRANCH_ID: 'branch_id',
    POSTMAN_ID: 'postman_id',
    NAME: 'name',
    PHONE: 'phone',
    INCLUDE_PRODUCT: 'include_products',
    COUNTS: 'counts',
    WEIGHT: 'weight',
    TIME_REQUEST: 'time_request',
    STATUS: 'status'
};

const preprint_type = {
    SMART_INVOICE: "smart_invoice",
    SMART_ENVELOPE: "smart_envelope"
};

const user_types = {
    MPOST: "mpost",
    AGENT: "agent",
    FCS: "fcs",
    MAIL_COLLECTOR: "mail_collector",
    ZA: 'za'
};

export const accept_types = {
    WALKIN: "walkin",
    COD: "cod"
};

const item_types = {
    LETTER: "letter",
    PARCEL: "parcel"
};

const label_types = {
    OWN_FLEET: "fcs_express",
    MM_POST: "mm_post",
    ALL_PARCEL: "all_parcel",
    ROYAL: "royal_express"
};

const purchase_types = {
    SENDER_PAY: 'sender_pay',
    RECEIVER_PAY: 'receiver_pay',
    CREDIT: 'credit',
    FROM_COD: 'from_cod'
};

const merchant_types = {
    NEW: 'new',
    EXISTING: 'existing'
};

const label_status_types = {
    PROCESS: 'process',
    ONGOING: 'ongoing',
    DELIVERED: 'delivered',
    RETURNED: 'returned',
};

const purchase_types_config = [
    {
        key: purchase_types.SENDER_PAY,
        locale_key: purchase_types.SENDER_PAY,
        available_for: {
            accept_type: [accept_types.WALKIN, accept_types.COD],
            label_type: [label_types.MM_POST, label_types.OWN_FLEET , label_types.ROYAL]
        },
        not_available_for: {}
    },
    {
        key: purchase_types.RECEIVER_PAY,
        locale_key: purchase_types.RECEIVER_PAY,
        available_for: {
            accept_type: [accept_types.WALKIN, accept_types.COD],
            label_type: [label_types.MM_POST, label_types.OWN_FLEET, label_types.ROYAL]
        },
        not_available_for: {
            gate_submit: [services.GATE_SUBMIT]
        }
    },
    {
        key: purchase_types.FROM_COD,
        locale_key: purchase_types.FROM_COD,
        available_for: {
            accept_type: [accept_types.COD],
            label_type: [label_types.MM_POST, label_types.OWN_FLEET, label_types.ROYAL]
        },
        not_available_for: {
            gate_submit: [services.GATE_SUBMIT]
        }
    },
    {
        key: purchase_types.CREDIT,
        locale_key: purchase_types.CREDIT,
        available_for: {
            accept_type: [accept_types.COD],
            label_type: [label_types.MM_POST, label_types.OWN_FLEET, label_types.ROYAL]
        },
        not_available_for: {}
    }
];

const service_types = {
    EXPRESS: 'express',
    VPP: 'vpp'
};

const service_types_config = [
    {
        key: service_types.EXPRESS,
        locale_key: service_types.EXPRESS,
        available_for: {
            label_type: [label_types.OWN_FLEET, label_types.MM_POST]
        }
    },
    {
        key: service_types.VPP,
        locale_key: service_types.VPP,
        available_for: {
            label_type: [label_types.MM_POST]
        }
    }
];


export default {
    api,
    services,
    enum_services_matcher,
    emo_form,
    cod_services_state,
    cod_clearance_transaction_state,
    emo_services_state,
    remark_type_enum,
    calcualtor_form,
    service_locale_enum,
    label_status_enum,
    label_status_process_enum,
    label_status_process_permission_enum,
    label_status_locale_enum,
    label_status_recognize_key,
    region_slug,
    country_slug,
    mailbag_process_enum,
    report_region_chooser_enum,
    report_period_enum,
    export_type_enum,
    report_type_enum,
    export_customer_enum,
    services_pricing,
    services_pricing_formula,
    location_type,
    location_response,
    tab_status_enum,
    agent_service_status,
    agent_available_services,
    pickup_request_status_enum,
    pickup_request_log_status_enum,
    pickup_request_api_enum,
    preprint_type,
    user_types,
    purchase_types,
    purchase_types_config,
    service_types,
    service_types_config,
    accept_types,
    label_types,
    item_types,
    merchant_types,
    label_service_type,
    label_status_types
};
